"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Image = function Image($uibModal, $http, SERVER_URL) {
  "ngInject";

  return {
    openDetail: openDetail,
    deleteImage: deleteImage
  };

  function openDetail(_imageSource, _imageId, _callback) {
    return $uibModal.open({
      component: 'imageDetail',
      // size: 'lg',
      resolve: {
        imageSource: function imageSource() {
          return _imageSource;
        },
        imageId: function imageId() {
          return _imageId;
        },
        callback: function callback() {
          return _callback;
        }
      }
    });
  }

  function deleteImage(id) {
    console.log("Delete image from service!", id);
    return $http.delete(SERVER_URL + "/images/" + id);
  }
};
exports.default = Image;


// WEBPACK FOOTER //
// ./client/app/services/imageService/image.service.js